import { BRAZE_CONTENT_CARD } from '@/components/braze/enums';
import {
  ESCRIPT_ORDERS_ROUTE,
  ESCRIPT_REFILL_PHARMACY_ROUTE,
  ESCRIPT_REFILL_ROUTE,
  PATIENT_ORDERS_ROUTE,
  PATIENT_REFILL_PHARMACY_ROUTE,
  PATIENT_REFILL_ROUTE,
} from '@/routes/route-paths';
import { ClassicContentCard } from '@montugroup/circuit-shared/components/braze/ClassicContentCard';
import { useLocation } from 'react-router-dom';

export const BrazePageMessaging = () => {
  const location = useLocation();

  switch (location.pathname) {
    case PATIENT_REFILL_ROUTE:
      return <ClassicContentCard page={BRAZE_CONTENT_CARD.PATIENT_REFILL} isTopBanner />;
    case PATIENT_REFILL_PHARMACY_ROUTE:
      return <ClassicContentCard page={BRAZE_CONTENT_CARD.PATIENT_REFILL_PHARMACY} isTopBanner />;
    case ESCRIPT_REFILL_ROUTE:
      return <ClassicContentCard page={BRAZE_CONTENT_CARD.ESCRIPT_REFILL} isTopBanner />;
    case ESCRIPT_REFILL_PHARMACY_ROUTE:
      return <ClassicContentCard page={BRAZE_CONTENT_CARD.ESCRIPT_REFILL_PHARMACY} isTopBanner />;
    case PATIENT_ORDERS_ROUTE:
      return <ClassicContentCard page={BRAZE_CONTENT_CARD.PATIENT_ORDERS} isTopBanner />;
    case ESCRIPT_ORDERS_ROUTE:
      return <ClassicContentCard page={BRAZE_CONTENT_CARD.ESCRIPT_ORDERS} isTopBanner />;
    default:
      break;
  }
};
